import {
	Component,
	OnInit,
	SecurityContext,
	ViewChild,
	AfterViewInit,
	ChangeDetectorRef,
	TemplateRef,
	ChangeDetectionStrategy,
	OnDestroy,
} from '@angular/core';
import { User } from '../../../models/User/user';
import { OperationError } from '../../../models/server-result/operation-error';
import { AppContextService } from '../../../services/app-context.service';
import { Router } from '@angular/router';
import { ToasterService } from '../../../shared-components/custom-toaster/toaster.service';
import { LogService } from '../../../services/log/log.service';
import { FilesIntegrationSearchCriteria } from '../../../models/file-integrations/files-integration-search-criteria';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { OperationResult } from '../../../models/server-result/operation-result';
import { CodeList } from '../../../models/common/code-list';
import { CompanyFileIntegrations } from '../../../models/companies/company-file-integrations';
import { PublicCompany } from '../../../models/companies/public-company';
import { FileAssociatedFundingRequestsExistence } from '../../../models/file-integrations/file-integration-associated.funding-requests';
import { IntegrationFileType } from '../../../models/enums/FileIntegration/integration-file-type';
import { FileIntegrationExistingAcceptances } from '../../../models/file-integrations/file-integration-existing-acceptances';
import { FileStatus } from '../../../models/enums/FileIntegration/integration-file-status';
import { TranslateService } from '../../../services/translate/translate.service';
import { Report } from '../../../models/reports/Report';
import { UtilitiesService } from '../../../services/utils/utilities.service';
import dayjs from '../../../services/dayjs-setup';
import { FileIntegrationViewModel } from './models/file-integration-view-model';
import { FileIntegration } from '../../../models/file-integrations/file-integration';
import { finalize, forkJoin } from 'rxjs';
import { FileIntegrationAmountsViewModel } from './models/file-integration-amounts-view-model';
import { CompanyFileParameters } from '../../../models/file-integrations/company-file-parameters';
import { DocumentExternalSource } from '../../../models/enums/document-external-source';
import { DomSanitizer } from '@angular/platform-browser';
import { FileIntegrationStateService } from '../../../services/file-integration-state.service';
import { FileDecisionHelperService } from '../../../services/file-integration/file-decision-helper.service';
import { FileIntegrationApiService } from '../../../server-api/file-integration-api/file-integration-api.service';
import { ApproveFilesByIds } from '../../../models/file-integrations/approve-files-by-ids';
import { RejectFilesByIds } from '../../../models/file-integrations/reject-files-by-ids';
import { FileIntegrationTabService } from '../../../services/file-integration-tab.service';
import { TableSelectAction } from '../../../shared-components/custom-table/components/table-toolbar/table-toolbar.component';
import {
	CustomTableFilterMapperService,
	FilterMappingConfig,
} from '../../../shared-components/custom-table/custom-table-filter-mapper.service';
import {
	TableColumn,
	TableExportOption,
	TableFilter,
	TableSearchEvent,
} from '../../../shared-components/custom-table/custom-table.types';
import { MenuItem } from '../../../shared-components/custom-menu/custom-menu.component';
import { BaseFilterableComponent } from '../../../shared-components/custom-table/base-filterable-component';
import { CustomTableComponent } from '../../../shared-components/custom-table/custom-table.component';
import { html } from '../../../utils/html-tag-utils';
import { FilenameCellComponent } from './components/filename-cell.component';
import { ReportingApiService } from '../../../server-api/reporting-api/reporting-api.service';
import { ReportingExportHelperService } from '../../../services/reporting-exports/reporting-export-helper.service';
import { CustomTableFilterService } from '../../../shared-components/custom-table/custom-table-filter.service';
import { CustomModalService } from '../../../shared-components/custom-modal/custom-modal.service';
import {
	FileIntegrationFileTypesEnum,
	FileIntegrationStatesEnum,
} from '../../../server-api/file-integration-api/file-integration-api.enums';

@Component({
	selector: 'app-file-integration-documents-advance-detail',
	templateUrl: './search-files-integration.component.html',
	styleUrls: ['./search-files-integration.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SearchFilesIntegrationComponent extends BaseFilterableComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild('customTable') customTable: CustomTableComponent;
	@ViewChild('decisionButton') decisionButton: TemplateRef<any>;

	public fileIntegrations: FileIntegrationViewModel[] = [];
	public fileAssociatedFundingRequestsExistence: FileAssociatedFundingRequestsExistence[] = [];
	public fileIntegrationExistingAcceptances: FileIntegrationExistingAcceptances[] = [];
	public FilesIntegrationSearchCriteria: FilesIntegrationSearchCriteria = new FilesIntegrationSearchCriteria();
	public requestErrors: OperationError[] = [];

	public fileSubmitingCompanies: PublicCompany[] = [];

	public fileStates: string[] = [];
	public fileTypeList: string[] = [];

	public isResourceLoaded: boolean;
	public isPerformingRequest: boolean = false;
	public loggedUser: User | null = null;
	public selectedFileStatus: string | null = null;

	private companyFilesParameters: CompanyFileParameters[] = [];
	public isTableReady = false;
	public isTableLoading = true;
	public selectActions: TableSelectAction[] = [];
	public selectedRows: FileIntegrationViewModel[] = [];
	public isCardView = false;
	public tableFilters: TableFilter[] = [];

	protected filterMappings: FilterMappingConfig[] = [
		{
			field: 'FileName',
			targetProperty: 'Filename',
			type: 'string',
		},
		{
			field: 'FileSubmitingCompany',
			targetProperty: 'FileSubmitingCompanyFilterList',
			type: 'array',
		},
		{
			field: 'ProcessingDate',
			targetProperty: 'CreationDateStart|CreationDateEnd',
			type: 'date-range',
		},
		{
			field: 'FileStatus',
			targetProperty: 'FileStatusList',
			type: 'array',
		},
	];

	protected searchCriteria = this.FilesIntegrationSearchCriteria;

	constructor(
		private fileIntegrationApiService: FileIntegrationApiService,
		public appContext: AppContextService,
		private toasterService: ToasterService,
		private router: Router,
		private logger: LogService,
		private modalService: CustomModalService,
		private translateService: TranslateService,
		private utilitiesService: UtilitiesService,
		private domSanitizer: DomSanitizer,
		private fileIntegrationStateService: FileIntegrationStateService,
		private fileDecisionHelperService: FileDecisionHelperService,
		private fileIntegrationTabService: FileIntegrationTabService,
		private cdr: ChangeDetectorRef,
		protected filterMapper: CustomTableFilterMapperService,
		private reportingApiService: ReportingApiService,
		private reportingExportHelperService: ReportingExportHelperService,
		private filterService: CustomTableFilterService
	) {
		super();
		this.fileIntegrationStateService.fileState$.subscribe((fileState) => {
			if (fileState) {
				this.selectedFileStatus = fileState;
				this.FilesIntegrationSearchCriteria.FileStatusList = [fileState];
				this.updateTableFiltersWithFileState(fileState);
			}
		});
	}

	ngOnInit() {
		this.setFilterMapper(this.filterMapper);
		this.initializeTableFilters();

		this.appContext.getLoggedUserAsync().subscribe((userResult) => {
			this.loggedUser = userResult.Data;
			this.loadListsForFilters();
		});
	}

	ngAfterViewInit() {
		this.selectActions = [
			{
				template: this.decisionButton,
				disabled: false,
			},
		];
		this.cdr.detectChanges();

		if (this.selectedFileStatus) {
			this.customTable?.triggerFinalRerender();
		}
	}

	ngOnDestroy() {
		this.fileIntegrationStateService.clearFileState();
	}

	private loadListsForFilters(): void {
		this.fileIntegrationApiService
			.getCodeListFileIntegrationStates()
			.pipe(
				finalize(() => {
					this.isPerformingRequest = false;
				})
			)
			.subscribe({
				next: (operationResult: OperationResult<CodeList<FileIntegrationStatesEnum>>) => {
					if (operationResult.IsValid) {
						this.fileStates = operationResult.Data.Codes;

						this.initializeTableFilters();

						if (this.selectedFileStatus) {
							this.FilesIntegrationSearchCriteria.FileStatusList = [this.selectedFileStatus];
							this.updateTableFiltersWithFileState(this.selectedFileStatus);
						}
					} else {
						this.toasterService.showError(
							this.translateService.translate('INVALID_RESULT_FROM_SERVER_FILESTATES_CODE_LIST', 'list-errorCodes')
						);
					}
				},
				error: (httpErrorResponse: HttpErrorResponse) => {
					console.error('error: ' + this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse.message));
					this.toasterService.showErrorFromHttpResponse(httpErrorResponse);
				},
			});

		this.getAccessibleCompaniesForUser();
	}

	public static navigateWithFileStatus(
		router: Router,
		fileIntegrationStateService: FileIntegrationStateService,
		fileStatus: string
	): Promise<boolean> {
		fileIntegrationStateService.setFileState(fileStatus);
		return router.navigate(['/private/files-integration/search']);
	}

	public onFileStatusChange(fileStatus: string): void {
		if (fileStatus) {
			this.FilesIntegrationSearchCriteria.FileStatusList = [fileStatus];
		} else {
			this.FilesIntegrationSearchCriteria.FileStatusList = [];
		}
	}

	public performSearch(pageNumber: number) {
		this.isTableLoading = true;
		this.tablePagination.pageIndex = pageNumber - 1;

		this.fileIntegrationExistingAcceptances = [];

		const criteria = new FilesIntegrationSearchCriteria();
		criteria.OrderBy = 'CreatedOn';
		criteria.OrderDescending = true;
		criteria.PageNumber = pageNumber;
		criteria.RowsPerPage = this.tablePagination.pageSize;
		criteria.RestrictionCriteria = this.FilesIntegrationSearchCriteria;
		this.isPerformingRequest = true;

		const serviceCallSearch = this.fileIntegrationApiService.searchFilesIntegration(criteria);
		const serviceCallCountSearch = this.fileIntegrationApiService.countSearchFilesIntegration(criteria.RestrictionCriteria);
		const serviceCallGetFilesParameters = this.fileIntegrationApiService.getFilesParameters(
			this.loggedUser?.Companies?.map((c) => c.Id!) ?? []
		);

		forkJoin([serviceCallSearch, serviceCallCountSearch, serviceCallGetFilesParameters])
			.pipe(
				finalize(() => {
					this.isResourceLoaded = true;
					this.isPerformingRequest = false;
					this.isTableLoading = false;
					this.cdr.detectChanges();
				})
			)
			.subscribe({
				next: ([searchResult, countResult, getFilesParametersResult]: [
					OperationResult<FileIntegration[]>,
					OperationResult<number>,
					OperationResult<CompanyFileParameters[]>,
				]) => {
					this.companyFilesParameters = getFilesParametersResult?.Data || [];

					if (!searchResult.IsValid) {
						this.processInvalidResult(searchResult);
						this.isPerformingRequest = false;
						return;
					}

					if (!countResult.IsValid) {
						this.processInvalidResult(countResult);
						this.isPerformingRequest = false;
						return;
					}

					if (searchResult.IsValid && countResult.IsValid) {
						let fileIntegrationsData = searchResult.Data.map((r) => {
							const fileIntegrationViewModel = <FileIntegrationViewModel>{
								CreatedBy: r.CreatedBy,
								CreatedOn: dayjs.utc(r.CreatedOn).tz(this.loggedUser?.TimeZone!).format('YYYY/MM/DD HH:mm'),
								FileId: r.FileId,
								FileName: r.FileName,
								FileStatus: r.FileStatus,
								FileType: r.FileType,
								RequiredDecisionForApproval: r.RequiredDecisionForApproval,
								ParsedDocumentPartitionsCount: r.ParsedDocumentPartitionsCount,
								UpdatedBy: r.UpdatedBy,
								UpdatedOn: r.UpdatedOn,
								FileAmounts:
									r.FileAmounts.length > 0
										? r.FileAmounts.map(
												(a) =>
													<FileIntegrationAmountsViewModel>{
														Currency: a.Currency,
														FileId: a.FileId,
														Id: a.Id,
														IntegratedDocumentsAmount: a.IntegratedDocumentsAmount,
														IntegratedDocumentsCount: a.IntegratedDocumentsCount,
													}
											)
										: [
												<FileIntegrationAmountsViewModel>{
													Currency: null,
													IntegratedDocumentsAmount: 0,
													IntegratedDocumentsCount: 0,
												},
											],
								FileRelatedCompaniesIds: r.FileRelatedCompaniesIds,
								HasFilePath: r.HasFilePath,
								FileRelatedContractId: r.FileRelatedContractId,
								FileRelatedContractProductType: r.FileRelatedContractProductType,
							};

							fileIntegrationViewModel.canSelect = false;

							return fileIntegrationViewModel;
						});

						this.SetFileIntegrationsSums(fileIntegrationsData);
						this.SetFileExistingAcceptances(fileIntegrationsData);

						this.fileIntegrations = [...fileIntegrationsData];

						if (!this.loggedUser?.IsSystemAdmin) {
							this.isPerformingRequest = true;
							this.fileDecisionHelperService
								.loadDocumentApproversForReceivedFiles(searchResult.Data)
								.then((receivedFilesDocumentApprovers) => {
									this.fileIntegrations = this.fileIntegrations.map((file) => {
										const approver = receivedFilesDocumentApprovers.find((x) => x.ReceivedFile.FileId === file.FileId);
										return approver ? { ...file, DocumentApprovers: approver.DocumentApprovers } : file;
									});

									this.updateAllCanSelectValues();

									this.cdr.detectChanges();
									this.cdr.markForCheck();

									this.customTable?.triggerFinalRerender();
								});
						}

						this.isPerformingRequest = false;
						this.isTableLoading = false;

						this.tablePagination.totalItems = countResult.Data;
						this.tablePagination = { ...this.tablePagination };

						this.cdr.markForCheck();

						this.customTable?.triggerFinalRerender();
					}
				},
				error: (httpErrorResponse: HttpErrorResponse) => {
					console.error('error: ' + httpErrorResponse.message);
					this.toasterService.showErrorFromHttpResponse(httpErrorResponse);

					this.customTable?.triggerFinalRerender();
				},
			});
	}

	private SetFileIntegrationsSums(fileIntegrations: FileIntegrationViewModel[]): void {
		if (!!fileIntegrations && fileIntegrations.some((f) => !!f.FileId)) {
			let filesIds = fileIntegrations.map((f) => f.FileId);

			this.isResourceLoaded = false;
			this.isPerformingRequest = true;

			this.fileIntegrationApiService
				.getFilesIntegratedAssociatedFundingRequestsExistence(filesIds)
				.pipe(
					finalize(() => {
						this.isResourceLoaded = true;
						this.isPerformingRequest = false;
					})
				)
				.subscribe({
					next: (operationResult: OperationResult<FileAssociatedFundingRequestsExistence[]>) => {
						if (operationResult.IsValid) {
							this.fileAssociatedFundingRequestsExistence = operationResult.Data;

							this.customTable?.triggerFinalRerender();
						} else {
							this.toasterService.showError(
								this.translateService.translate(
									'search-files-integration.invalid-result-from-server-get-file-associated-funding-requests-existence',
									'client'
								)
							);
						}
					},
					error: (httpErrorResponse: HttpErrorResponse) => {
						console.error('error: ' + this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse.message));
						this.toasterService.showErrorFromHttpResponse(httpErrorResponse);

						this.customTable?.triggerFinalRerender();
					},
				});
		}
	}

	private SetFileExistingAcceptances(fileIntegrations: FileIntegrationViewModel[]): void {
		if (!!fileIntegrations && fileIntegrations.some((f) => !!f.FileId)) {
			let filesIds = fileIntegrations.map((f) => f.FileId);

			this.isResourceLoaded = false;
			this.isPerformingRequest = true;

			this.fileIntegrationApiService
				.retrieveFilesExistingAcceptances(filesIds)
				.pipe(
					finalize(() => {
						this.isResourceLoaded = true;
						this.isPerformingRequest = false;
					})
				)
				.subscribe({
					next: (operationResult: OperationResult<FileIntegrationExistingAcceptances[]>) => {
						if (operationResult.IsValid) {
							this.fileIntegrationExistingAcceptances = operationResult.Data;

							this.fileIntegrationExistingAcceptances.forEach((fileIntegrationExistingAcceptance) => {
								fileIntegrationExistingAcceptance.FilesIntegrationDecisions.forEach((fileDecision) => {
									fileDecision.DecisionDate = dayjs
										.utc(fileDecision.DecisionDate)
										.tz(this.loggedUser?.TimeZone!)
										.format('YYYY/MM/DD HH:mm');
								});
							});

							this.updateAllCanSelectValues();
						} else {
							this.toasterService.showError(
								this.translateService.translate('search-files-integration.invalid-result-from-server-get-file-existing-decisions', 'client')
							);
						}
					},
					error: (httpErrorResponse: HttpErrorResponse) => {
						console.error('error: ' + this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse.message));
						this.toasterService.showErrorFromHttpResponse(httpErrorResponse);

						this.customTable?.triggerFinalRerender();
					},
				});
		}
	}

	private getAccessibleCompaniesForUser(): void {
		const isSystemUser =
			!!this.loggedUser && (this.loggedUser.IsSystemAdmin || this.loggedUser.IsSupportOperator || this.loggedUser.IsBackOfficeOperator);

		if (isSystemUser) {
			this.fileSubmitingCompanies = [];

			this.fileIntegrationApiService.getCodeListFileIntegrationFileTypes().subscribe({
				next: (operationResult: OperationResult<CodeList<FileIntegrationFileTypesEnum>>) => {
					operationResult.IsValid
						? (this.fileTypeList = operationResult.Data.Codes)
						: this.toasterService.showError(
								this.translateService.translate('search-files-integration.invalid-result-from-server-filetypelist-code-list', 'client')
							);
				},
				error: (httpErrorResponse: HttpErrorResponse) => {
					console.error('error: ' + this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse.message));
					this.toasterService.showErrorFromHttpResponse(httpErrorResponse);

					this.customTable?.triggerFinalRerender();
				},
			});

			this.fileIntegrationApiService.companyFileIntegration([]).subscribe((opResults: OperationResult<CompanyFileIntegrations[]>) => {
				if (opResults.IsValid && !!opResults.Data && opResults.Data.map((d) => d.CompanyFileSourceFileTypes).some((f) => !!f)) {
					this.fileSubmitingCompanies = opResults.Data.filter((d) => d.CompanyFileSourceFileTypes.some((f) => !!f)).map((c) => c.Company);
				} else
					console.error(
						'Event caught at search-files-integration component: ' +
							this.domSanitizer.sanitize(SecurityContext.HTML, opResults.Errors ?? [])
					);

				this.initializeTableFilters();
			});
		}

		if (!!this.loggedUser && this.loggedUser.Companies?.some((c) => !!c)) {
			this.fileIntegrationApiService
				.companyFileIntegration(this.loggedUser.Companies.map((c) => c.Id!))
				.subscribe((opResults: OperationResult<CompanyFileIntegrations[]>) => {
					if (opResults.IsValid && !!opResults.Data && opResults.Data.map((d) => d.CompanyFileSourceFileTypes).some((f) => !!f)) {
						this.fileSubmitingCompanies = opResults.Data.filter((d) => d.CompanyFileSourceFileTypes.some((f) => !!f)).map((c) => c.Company);

						this.fileTypeList = [];

						let fileTypesAssociatedToCompanies = opResults.Data.map((d) => d.CompanyFileSourceFileTypes).reduce(function (
							acumulador,
							currentValue
						) {
							return acumulador.concat(currentValue);
						}, []);

						this.fileTypeList = fileTypesAssociatedToCompanies.map((c) => c.FileType).filter((x, i, a) => a.indexOf(x) == i);
					} else
						console.error(
							'Event caught at search-files-integration component: ' +
								this.domSanitizer.sanitize(SecurityContext.HTML, opResults.Errors ?? [])
						);

					this.initializeTableFilters();
				});
		}
	}

	public showFileAssociatedDocumentsIcon(fileIntegration: FileIntegrationViewModel): boolean {
		if (!!fileIntegration) {
			if (fileIntegration.FileType == IntegrationFileType.JM_DocumentsToAdvance) {
				return this.showFileAssociatedDocumentsIconForDocumentsToAdvance(fileIntegration);
			} else if (
				fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type2_CSV ||
				fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type3_PSV ||
				fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type1_XLSX
			) {
				return this.showFileAssociatedDocumentsIconForConfirmingDocuments(fileIntegration);
			} else if (fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type1_XML) {
				return this.showFileAssociatedDocumentsIconForConfirmingDocumentsAndSuppliers(fileIntegration);
			} else if (fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type2_PSV) {
				return this.showFileAssociatedDocumentsIconForConfirmingDocumentsAndSuppliers(fileIntegration);
			} else if (fileIntegration.FileType == IntegrationFileType.FactoringDocuments_Type1_XLSX) {
				return this.showFileAssociatedDocumentsIconForFactoringDocuments(fileIntegration);
			}
		}

		return false;
	}

	public showFileDownloadIcon(fileIntegration: FileIntegrationViewModel): boolean {
		if (!this.loggedUser?.IsSystemAdmin && !this.loggedUser?.IsSupportOperator && !this.loggedUser?.IsBackOfficeOperator) return false;

		if (!!fileIntegration) return fileIntegration?.HasFilePath;

		return false;
	}

	private showFileAssociatedDocumentsIconForDocumentsToAdvance(fileIntegration: FileIntegrationViewModel): boolean {
		if (!!fileIntegration) {
			let docCountPerCurrency = fileIntegration.FileAmounts.map((a) => a.IntegratedDocumentsCount).reduce(function (sum, docCount) {
				return sum + docCount;
			}, 0);
			let fileSumFound = docCountPerCurrency > 0;
			let fileStatusAllowDocumentsSearch =
				fileIntegration.FileStatus == FileStatus.Approved || fileIntegration.FileStatus == FileStatus.PendingBuyerApproval;

			return fileSumFound && fileStatusAllowDocumentsSearch && fileIntegration.FileType == IntegrationFileType.JM_DocumentsToAdvance;
		}

		return false;
	}

	private showFileAssociatedDocumentsIconForConfirmingDocuments(fileIntegration: FileIntegrationViewModel): boolean {
		if (!!fileIntegration) {
			let docCountPerCurrency = fileIntegration.FileAmounts.map((a) => a.IntegratedDocumentsCount).reduce(function (sum, docCount) {
				return sum + docCount;
			}, 0);
			let fileSumFound = docCountPerCurrency > 0;
			let fileStatusAllowDocumentsSearch =
				fileIntegration.FileStatus == FileStatus.Approved || fileIntegration.FileStatus == FileStatus.PendingBuyerApproval;

			return (
				fileSumFound &&
				fileStatusAllowDocumentsSearch &&
				(fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type2_CSV ||
					fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type3_PSV ||
					fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type1_XLSX)
			);
		}

		return false;
	}

	private showFileAssociatedDocumentsIconForConfirmingDocumentsAndSuppliers(fileIntegration: FileIntegrationViewModel): boolean {
		if (!!fileIntegration) {
			let docCountPerCurrency = fileIntegration.FileAmounts.map((a) => a.IntegratedDocumentsCount).reduce(function (sum, docCount) {
				return sum + docCount;
			}, 0);
			let fileSumFound = docCountPerCurrency > 0;
			let fileStatusAllowDocumentsSearch =
				fileIntegration.FileStatus == FileStatus.Approved || fileIntegration.FileStatus == FileStatus.PendingBuyerApproval;

			return (
				fileSumFound &&
				fileStatusAllowDocumentsSearch &&
				(fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type1_XML ||
					fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type2_PSV)
			);
		}

		return false;
	}

	private showFileAssociatedDocumentsIconForFactoringDocuments(fileIntegration: FileIntegrationViewModel): boolean {
		if (!!fileIntegration) {
			let docCountPerCurrency = fileIntegration.FileAmounts.map((a) => a.IntegratedDocumentsCount).reduce(function (sum, docCount) {
				return sum + docCount;
			}, 0);
			let fileSumFound = docCountPerCurrency > 0;
			let fileStatusAllowDocumentsSearch =
				fileIntegration.FileStatus == FileStatus.Registered || fileIntegration.FileStatus == FileStatus.PendingSupplierApproval;

			return (
				fileSumFound && fileStatusAllowDocumentsSearch && fileIntegration.FileType == IntegrationFileType.FactoringDocuments_Type1_XLSX
			);
		}

		return false;
	}

	public showFileAssociatedFundingRequestsIcon(fileIntegration: FileIntegrationViewModel): boolean {
		if (!!this.fileAssociatedFundingRequestsExistence) {
			let fileSumFound = this.fileAssociatedFundingRequestsExistence.find((f) => f.FileId == fileIntegration.FileId);
			let fileStatusAllowFundingSearch =
				fileIntegration.FileStatus == FileStatus.Approved || fileIntegration.FileStatus == FileStatus.PendingBuyerApproval;

			return (
				!!fileSumFound &&
				fileStatusAllowFundingSearch &&
				fileIntegration.FileType == IntegrationFileType.JM_DocumentsToAdvance &&
				fileSumFound.FundingRequestsCount > 0
			);
		}

		return false;
	}

	public redirectToFileAssociatedDocuments(fileIntegration: FileIntegrationViewModel): void {
		if (!!fileIntegration) {
			let docCountPerCurrency = fileIntegration.FileAmounts.map((a) => a.IntegratedDocumentsCount).reduce(function (sum, docCount) {
				return sum + docCount;
			}, 0);
			let fileSumFound = docCountPerCurrency > 0;

			if (!!fileSumFound && fileIntegration.FileType == IntegrationFileType.JM_DocumentsToAdvance) {
				this.router.navigate(['/private/documents/fileIntegration', fileIntegration.FileId]);
			} else if (
				!!fileSumFound &&
				(fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type2_CSV ||
					fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type3_PSV ||
					fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type1_XLSX)
			) {
				this.router.navigate(['/private/documents/fileIntegration', fileIntegration.FileId]);
			} else if (!!fileSumFound && fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type1_XML) {
				this.router.navigate(['/private/documents/fileIntegration', fileIntegration.FileId]);
			} else if (!!fileSumFound && fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type2_PSV) {
				this.router.navigate(['/private/documents/fileIntegration', fileIntegration.FileId]);
			} else if (!!fileSumFound && fileIntegration.FileType == IntegrationFileType.FactoringDocuments_Type1_XLSX) {
				this.router.navigate(['/private/documents/fileIntegration', fileIntegration.FileId]);
			}
		}
	}

	public redirectToFileAssociatedFundingRequests(fileIntegration: FileIntegrationViewModel): void {
		if (!!this.fileAssociatedFundingRequestsExistence) {
			let fileSumFound = this.fileAssociatedFundingRequestsExistence.find((f) => f.FileId == fileIntegration.FileId);

			if (!!fileSumFound) {
				this.router.navigate(['/private/funding-request/fileIntegration', fileIntegration.FileId]);
			}
		}
	}

	public showPreviousDecisions(): boolean {
		return this.loggedUser != null && (this.loggedUser?.IsSystemAdmin || this.loggedUser?.IsBuyer || this.loggedUser?.IsFactoringSupplier);
	}

	public showIntegratinDetails(fileIntegration: FileIntegrationViewModel): boolean {
		let userCanSeeDetails =
			this.loggedUser != null &&
			(this.loggedUser?.IsSystemAdmin ||
				this.loggedUser?.IsSupportOperator ||
				this.loggedUser?.IsBackOfficeOperator ||
				this.loggedUser?.IsBuyer ||
				this.loggedUser?.IsFactoringSupplier);

		let documentsToAdvanceFileStatusAllowDecision =
			!!fileIntegration &&
			fileIntegration.FileType == IntegrationFileType.JM_DocumentsToAdvance &&
			fileIntegration.FileStatus != FileStatus.Processing;

		let confirmingDocumentRecordsFileStatusAllowDecision =
			!!fileIntegration &&
			(fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type2_CSV ||
				fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type3_PSV ||
				fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type1_XLSX) &&
			fileIntegration.FileStatus != FileStatus.Processing &&
			fileIntegration.FileStatus != FileStatus.WaitingProcess;

		let confirmingDocumentsAndSuppliersRecordsFileStatusAllowDecision =
			!!fileIntegration &&
			(fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type1_XML ||
				fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type2_PSV) &&
			fileIntegration.FileStatus != FileStatus.Processing &&
			fileIntegration.FileStatus != FileStatus.WaitingProcess;

		let confirmingSuppliersRecordsFileStatusAllowDecision =
			!!fileIntegration &&
			fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliers_Type2_CSV &&
			fileIntegration.FileStatus != FileStatus.Processing &&
			fileIntegration.FileStatus != FileStatus.WaitingProcess;

		let factoringDocumentRecordsFileStatusAllowDecision =
			!!fileIntegration &&
			fileIntegration.FileType == IntegrationFileType.FactoringDocuments_Type1_XLSX &&
			fileIntegration.FileStatus != FileStatus.Processing &&
			fileIntegration.FileStatus != FileStatus.WaitingProcess;

		return (
			userCanSeeDetails &&
			(documentsToAdvanceFileStatusAllowDecision ||
				confirmingDocumentRecordsFileStatusAllowDecision ||
				confirmingDocumentsAndSuppliersRecordsFileStatusAllowDecision ||
				confirmingSuppliersRecordsFileStatusAllowDecision ||
				factoringDocumentRecordsFileStatusAllowDecision)
		);
	}

	public showIntegratedDocumentsAmount(): boolean {
		return this.loggedUser != null && (this.loggedUser?.IsSystemAdmin || this.loggedUser?.IsBuyer || this.loggedUser?.IsFactoringSupplier);
	}

	public canMakeDecision(fileIntegration: FileIntegrationViewModel): boolean {
		return (
			this.fileDecisionHelperService.canMakeDecision(this.loggedUser!, fileIntegration, fileIntegration?.DocumentApprovers) &&
			!this.userAlreadyDecided(fileIntegration)
		);
	}

	public userAlreadyDecided(fileIntegration: FileIntegrationViewModel): boolean {
		if (!this.fileIntegrationExistingAcceptances || this.fileIntegrationExistingAcceptances.length === 0) {
			return false;
		}

		let fileDecisions = this.fileIntegrationExistingAcceptances.find((f) => !!f && f.FileId == fileIntegration.FileId);
		if (!!fileDecisions && !!fileDecisions.FilesIntegrationDecisions) {
			return fileDecisions.FilesIntegrationDecisions.some((d) => d.DecisionBy === this.loggedUser?.Username);
		}

		return false;
	}

	public confirmFileRejection(fileIntegration: FileIntegrationViewModel | FileIntegrationViewModel[]): void {
		const isBulkAction = Array.isArray(fileIntegration) && fileIntegration.length > 1;

		this.customTable?.setBulkActionContext(isBulkAction);

		const files = Array.isArray(fileIntegration) ? fileIntegration : [fileIntegration];
		const fileIds = files.map((f) => f.FileId);

		const displayText =
			files.length > 1 ? `${files.length} ${this.translateService.translate('file-integrations.files', 'client')}` : files[0].FileName;

		const modalRef = this.modalService.confirm({
			size: 'lg',
			title: this.translateService.translate('file-integrations.modalConfirmDialogRejectFileTitle', 'client'),
			body: {
				content: this.translateService.translate('file-integrations.modal.reject', 'client').replace('[FILES]', displayText),
			},
		});

		modalRef.result
			.then((confirmed) => {
				if (!confirmed) {
					return;
				}

				const fileRejectionServiceCall = this.fileIntegrationApiService.rejectReceivedFilesByIds(<RejectFilesByIds>{
					FileIds: fileIds,
				});

				this.isPerformingRequest = true;

				fileRejectionServiceCall
					.pipe(
						finalize(() => {
							this.isPerformingRequest = false;
							this.cdr.detectChanges();
						})
					)
					.subscribe({
						next: (operationResult: OperationResult<boolean>) => {
							if (operationResult.IsValid) {
								let sucessMessage = this.translateService
									.translate('file-integrations.sucessInRejection', 'client')
									.replace('[FILES]', displayText);
								this.toasterService.showSuccess(sucessMessage);

								this.customTable?.clearSpecificSelections(fileIds);
								this.performSearch(1);
							} else {
								let errors = operationResult.Errors;

								if (errors && errors.length > 0) {
									this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
										errors: errors,
										autoClose: false,
									});
								}
								this.performSearch(1);
							}
						},
						error: (httpErrorResponse: HttpErrorResponse) => {
							this.logger.error(
								'[SearchFilesIntegration::Reject File] HttpErrorResponse: ',
								this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
							);

							this.toasterService.showError(
								'[SearchFilesIntegration::Reject File] HttpErrorResponse: ' + httpErrorResponse.error + httpErrorResponse.message
							);
						},
					});
			})
			.catch(() => undefined);
	}

	public confirmFileApproval(fileIntegration: FileIntegrationViewModel | FileIntegrationViewModel[]): void {
		const isBulkAction = Array.isArray(fileIntegration) && fileIntegration.length > 1;

		this.customTable?.setBulkActionContext(isBulkAction);

		const files = Array.isArray(fileIntegration) ? fileIntegration : [fileIntegration];
		const fileIds = files.map((f) => f.FileId);

		const displayText =
			files.length > 1 ? `${files.length} ${this.translateService.translate('file-integrations.files', 'client')}` : files[0].FileName;

		const modalRef = this.modalService.confirm({
			size: 'lg',
			title: this.translateService.translate('file-integrations.modalConfirmDialogApprovalFileTitle', 'client'),
			body: {
				content: this.translateService.translate('file-integrations.modal.approve', 'client').replace('[FILES]', displayText),
			},
		});

		modalRef.result
			.then(
				(confirmed) => {
					if (!confirmed) {
						return;
					}

					const fileAcceptServiceCall = this.fileIntegrationApiService.acceptReceivedFilesByIds(<ApproveFilesByIds>{
						FileIds: fileIds,
					});

					this.isPerformingRequest = true;

					fileAcceptServiceCall
						.pipe(
							finalize(() => {
								this.isPerformingRequest = false;
								this.cdr.detectChanges();
							})
						)
						.subscribe({
							next: (operationResult: OperationResult<boolean>) => {
								if (operationResult.IsValid) {
									let sucessMessage = this.translateService
										.translate('file-integrations.sucessInApproving', 'client')
										.replace('[FILES]', displayText);
									this.toasterService.showSuccess(sucessMessage);

									this.customTable?.clearSpecificSelections(fileIds);
									this.performSearch(1);
								} else {
									let errors = operationResult.Errors;

									if (errors && errors.length > 0) {
										this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
											errors: errors,
											autoClose: false,
										});
									}
									this.performSearch(1);
								}
							},
							error: (httpErrorResponse: HttpErrorResponse) => {
								this.logger.error(
									'[SearchFilesIntegration::Approve File] HttpErrorResponse: ',
									this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
								);

								this.toasterService.showError(
									'[SearchFilesIntegration::Approve File] HttpErrorResponse: ' + httpErrorResponse.error + httpErrorResponse.message
								);
							},
						});
				},
				() => {}
			)
			.catch((error) => console.error('Error from modal' + this.domSanitizer.sanitize(SecurityContext.HTML, error)));
	}

	public canExportFileIntegrationSearchResults(): boolean {
		return this.tablePagination.totalItems > 0;
	}

	public tableExport: TableExportOption = {
		label: 'file-integrations.exportDocuments',
		action: () => this.exportIntegratedFiles(),
		condition: () => this.canExportFileIntegrationSearchResults(),
	};

	public exportIntegratedFiles = (): void => {
		this.isPerformingRequest = true;

		this.reportingApiService.exportIntegratedFiles(this.FilesIntegrationSearchCriteria).subscribe({
			next: (operationResult: OperationResult<Report>) => {
				if (operationResult.IsValid && operationResult.Data) {
					this.reportingExportHelperService.processValidReport(operationResult.Data);
				} else {
					this.reportingExportHelperService.processInvalidReport(operationResult, 'Invalid result from server export integrated files');
				}

				this.isPerformingRequest = false;
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				console.error('error: ' + this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse.message));
				this.toasterService.showErrorFromHttpResponse(httpErrorResponse);

				this.isPerformingRequest = false;
			},
			complete: () => {
				this.tableExport = { ...this.tableExport, exporting: false };
				this.cdr.detectChanges();
			},
		});
	};

	public gotoFileUpload(): void {
		this.router.navigate(['/private/files-upload/upload/files']);
	}

	public showFileUploadButton(): boolean {
		if (!this.loggedUser) {
			return false;
		}

		if (this.loggedUser.IsSystemAdmin) {
			return true;
		}

		let associatedCompaniesWithUploadableFiles = !!this.companyFilesParameters?.some(
			(f) => f.FileType != IntegrationFileType.JM_DocumentsToAdvance && f.FileSource == DocumentExternalSource.FILE_UPLOAD
		);

		if (this.loggedUser.IsFinancier && this.loggedUser.IsCompanyAdmin && associatedCompaniesWithUploadableFiles) {
			return true;
		}

		return false;
	}

	public getFileDetailLink(fileIntegration: FileIntegrationViewModel): string | null {
		if (fileIntegration.FileType == IntegrationFileType.JM_DocumentsToAdvance) {
			return '/private/files-integration/file/detail/' + fileIntegration?.FileId;
		} else if (
			fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type2_CSV ||
			fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type3_PSV ||
			fileIntegration.FileType == IntegrationFileType.ConfirmingDocuments_Type1_XLSX
		) {
			return '/private/files-integration/file/detail/' + fileIntegration?.FileId;
		} else if (fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type1_XML) {
			return '/private/files-integration/file/detail/' + fileIntegration?.FileId;
		} else if (fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliersAndDocuments_Type2_PSV) {
			return '/private/files-integration/file/detail/' + fileIntegration?.FileId;
		} else if (fileIntegration.FileType == IntegrationFileType.ConfirmingSuppliers_Type2_CSV) {
			return '/private/files-integration/file/detail/' + fileIntegration?.FileId;
		} else if (fileIntegration.FileType == IntegrationFileType.FactoringDocuments_Type1_XLSX) {
			return '/private/files-integration/file/detail/' + fileIntegration?.FileId;
		}

		return null;
	}

	private processInvalidResult<T>(operationResult: OperationResult<T>): void {
		let errors = operationResult.Errors;

		if (errors && errors.length > 0) {
			this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
				errors: errors,
				autoClose: false,
			});
		}
	}

	public getFormatedIntegratedDocumentsCountValues(amounts: FileIntegrationAmountsViewModel[]): string[] {
		let formatedAmounts: string[] = [];

		if (amounts?.length == 1) {
			const amount = amounts[0];
			formatedAmounts.push(this.getFormatedIntegratedDocumentsCountValueNotShowingCurrency(amount));
		} else if (amounts?.length > 1) {
			for (let index = 0; index < amounts.length; index++) {
				const amount = amounts[index];

				if (!!amount) {
					if (!amount?.Currency?.trim()) formatedAmounts.push(this.getFormatedIntegratedDocumentsCountValueNotShowingCurrency(amount));
					else formatedAmounts.push(this.getFormatedIntegratedDocumentsCountValueWhenCurrencyHasValue(amount));
				}
			}
		}

		return formatedAmounts;
	}

	private getFormatedIntegratedDocumentsCountValueNotShowingCurrency(amount: FileIntegrationAmountsViewModel): string {
		return amount.IntegratedDocumentsCount.toString();
	}

	private getFormatedIntegratedDocumentsCountValueWhenCurrencyHasValue(amount: FileIntegrationAmountsViewModel): string {
		return amount.IntegratedDocumentsCount.toString() + ' (' + amount.Currency + ')';
	}

	public downloadFile(fileIntegration: FileIntegrationViewModel): void {
		this.isPerformingRequest = true;

		this.fileIntegrationApiService.downloadIntegratedfile(fileIntegration.FileId).subscribe({
			next: (operationResult: HttpResponse<Blob>) => {
				this.utilitiesService.openBlobNewWindowWithName(operationResult.body, fileIntegration.FileName);

				this.isPerformingRequest = false;
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				console.error('error: ' + this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse.message));
				this.toasterService.showErrorFromHttpResponse(httpErrorResponse);
				this.isPerformingRequest = false;
			},
		});
	}

	public hasActions(fileIntegration: FileIntegrationViewModel): boolean {
		return (
			this.showFileDownloadIcon(fileIntegration) ||
			this.showFileAssociatedDocumentsIcon(fileIntegration) ||
			this.showFileAssociatedFundingRequestsIcon(fileIntegration) ||
			this.canMakeDecision(fileIntegration)
		);
	}

	public canSelectFile(fileIntegration: FileIntegrationViewModel): boolean {
		return this.canMakeDecision(fileIntegration);
	}

	private updateAllCanSelectValues(): void {
		if (this.fileIntegrations && this.fileIntegrations.length > 0) {
			this.fileIntegrations = this.fileIntegrations.map((file) => ({
				...file,
				canSelect: this.canSelectFile(file),
			}));

			this.cdr.detectChanges();
			this.cdr.markForCheck();

			this.customTable?.triggerFinalRerender();
		}
	}

	public hasSelectableFiles(): boolean {
		return !!this.fileIntegrations && this.fileIntegrations.some((file) => this.canSelectFile(file));
	}

	public getFileSubmitingCompanyName(fileIntegration: FileIntegrationViewModel): { companyName: string; completeVatNumber: string } {
		return {
			companyName:
				this.fileSubmitingCompanies.find((company) => fileIntegration.FileRelatedCompaniesIds.includes(company.Id))?.Name || 'N/A',
			completeVatNumber: `${
				this.fileSubmitingCompanies.find((company) => fileIntegration.FileRelatedCompaniesIds.includes(company.Id))?.CountryCode || ''
			}${this.fileSubmitingCompanies.find((company) => fileIntegration.FileRelatedCompaniesIds.includes(company.Id))?.VatNumber || '-'}`,
		};
	}

	public navigateToDocuments(fileIntegration: FileIntegrationViewModel) {
		this.fileIntegrationTabService.setSelectedTab('documents');
		const baseUrl = `/private/files-integration/file/detail/${fileIntegration.FileId}`;
		this.router.navigate([baseUrl]);
	}

	public navigateToAdvancedDocuments(fileIntegration: FileIntegrationViewModel) {
		this.fileIntegrationTabService.setSelectedTab('advanced-payments');
		const baseUrl = `/private/files-integration/file/detail/${fileIntegration.FileId}`;
		this.router.navigate([baseUrl]);
	}

	public resetTabState(): void {
		this.fileIntegrationTabService.setSelectedTab('details');
	}

	private initializeTableFilters() {
		this.tableFilters = [
			{
				field: 'FileName',
				type: 'text',
				value: null,
				placeholder: this.translateService.translate('file-integrations.fileName', 'client'),
			},
			{
				field: 'FileSubmitingCompany',
				type: 'select',
				value: null,
				options: this.fileSubmitingCompanies.map((company) => ({
					value: company.Id,
					label: company.Name,
				})),
				placeholder: this.translateService.translate('file-integrations.fileSubmitingCompany', 'client'),
			},
			{
				field: 'ProcessingDate',
				type: 'date-picker',
				value: [dayjs().subtract(2, 'month').toISOString(), dayjs().toISOString()],
				placeholder: this.translateService.translate('file-integrations.processingDate', 'client'),
				metadata: {
					datePickerConfig: {
						calendars: 2,
						isRange: true,
						format: 'YYYY/MM/DD',
					},
				},
			},
			{
				field: 'FileStatus',
				type: 'select',
				value: this.selectedFileStatus ? [this.selectedFileStatus] : null,
				options: this.fileStates.map((state) => ({
					value: state,
					label: this.translateService.translate(state, 'list-fileIntegrationState'),
				})),
				placeholder: this.translateService.translate('file-integrations.fileState', 'client'),
			},
		];
	}

	public tableColumns: TableColumn[] = [
		{
			field: 'FileName',
			header: 'file-integrations.fileName',
			render: FilenameCellComponent,
			inputs: (row: FileIntegrationViewModel) => ({
				showDetails: this.showIntegratinDetails(row),
				detailLink: this.getFileDetailLink(row),
				displayText: row.FileName,
				tooltip: row.FileName,
			}),
		},
		{
			field: 'FileSubmitingCompany',
			header: 'file-integrations.fileSubmitingCompany',
			align: 'left',
			render: (row: FileIntegrationViewModel) => {
				const companyInfo = this.getFileSubmitingCompanyName(row);
				return html`
					<p class="truncate">${companyInfo.companyName}</p>
					<span>${companyInfo.completeVatNumber}</span>
				`;
			},
			tooltip: (row: FileIntegrationViewModel) => {
				const companyInfo = this.getFileSubmitingCompanyName(row);
				return `${companyInfo.companyName} ${companyInfo.completeVatNumber}`;
			},
		},
		{
			field: 'ProcessedRecords',
			header: 'file-integrations.fileProcessedRecords',
			align: 'right',
			render: (row: FileIntegrationViewModel) => {
				return html`<span class="is-bold">${row.FileAmounts[0]?.IntegratedDocumentsCount || 0}</span>`;
			},
		},
		{
			field: 'ProcessedAmount',
			header: 'file-integrations.fileDocumentsProcessedAmount',
			align: 'right',
			render: (row: FileIntegrationViewModel) => {
				const amount = row.FileAmounts[0]?.IntegratedDocumentsAmount || 0;
				const currency = row.FileAmounts[0]?.Currency || '';
				return html`<span class="is-bold">${amount} ${currency}</span>`;
			},
			condition: () => this.showIntegratedDocumentsAmount(),
		},
		{
			field: 'ProcessingDate',
			header: 'file-integrations.processingDate',
			align: 'center',
			render: (row: FileIntegrationViewModel) => {
				return html`<span>${row.CreatedOn}</span>`;
			},
		},
		{
			field: 'FileStatus',
			header: 'file-integrations.fileState',
			align: 'center',
			render: (row: FileIntegrationViewModel) => {
				return html`<span class="tag ${row.FileStatus}">
					${this.translateService.translate(row.FileStatus, 'list-fileIntegrationState')}
				</span>`;
			},
		},
		{
			type: 'actions',
			icon: 'fa-solid fa-ellipsis-v',
			isMenu: true,
			showActions: (row: FileIntegrationViewModel) => this.hasActions(row),
			menuItems: [
				{
					icon: 'fa-regular fa-arrow-down-to-line',
					label: this.translateService.translate('file-integrations.downloadFile', 'client'),
					action: (row) => this.downloadFile(row),
					condition: (row: FileIntegrationViewModel) => this.showFileDownloadIcon(row),
				},
				{
					icon: 'fa-regular fa-file-invoice',
					label: this.translateService.translate('file-integrations.viewAssociatedDocuments', 'client'),
					action: (row) => this.navigateToDocuments(row),
					condition: (row: FileIntegrationViewModel) => this.showFileAssociatedDocumentsIcon(row),
				},
				{
					icon: 'fa-regular fa-hand-holding-usd',
					label: this.translateService.translate('file-integrations.viewAssociatedFundingRequests', 'client'),
					action: (row) => this.navigateToAdvancedDocuments(row),
					condition: (row: FileIntegrationViewModel) => this.showFileAssociatedFundingRequestsIcon(row),
				},
				{
					isSeparator: true,
					condition: (row: FileIntegrationViewModel) => this.canMakeDecision(row),
				},
				{
					icon: 'fa-solid fa-check',
					label: this.translateService.translate('file-integrations.decisionApprove', 'client'),
					action: (row) => this.confirmFileApproval(row),
					condition: (row: FileIntegrationViewModel) => this.canMakeDecision(row),
				},
				{
					icon: 'fa-regular fa-times',
					label: this.translateService.translate('file-integrations.decisionReject', 'client'),
					action: (row) => this.confirmFileRejection(row),
					condition: (row: FileIntegrationViewModel) => this.canMakeDecision(row),
				},
			],
		},
	];

	public onSearchRequested(event: TableSearchEvent): void {
		this.FilesIntegrationSearchCriteria = new FilesIntegrationSearchCriteria();
		this.FilesIntegrationSearchCriteria.OrderDescending = true;
		this.searchCriteria = this.FilesIntegrationSearchCriteria;

		if (this.filterMapper && event.filters?.length > 0) {
			this.filterMapper.mapFiltersToObject(event.filters, this.filterMappings, this.searchCriteria);
		}

		this.tablePagination.pageIndex = event.pageIndex;
		this.tablePagination.pageSize = event.pageSize;

		const pageNumber = event.pageIndex + 1;
		this.performSearch(pageNumber);
	}

	onSelectionChange(selectionEvent: any): void {
		if (selectionEvent.selectedRows) {
			this.selectedRows = selectionEvent.selectedRows;
		} else if (Array.isArray(selectionEvent)) {
			this.selectedRows = selectionEvent;
		}
	}

	public getDecisionMenuItems: MenuItem[] = [
		{
			text: this.translateService.translate('file-integrations.DecisionApprove', 'client'),
			icon: 'fa-solid fa-check',
			color: 'success',
			action: () => this.confirmFileApproval(this.selectedRows),
		},
		{
			text: this.translateService.translate('file-integrations.DecisionReject', 'client'),
			icon: 'fa-regular fa-times',
			color: 'danger',
			action: () => this.confirmFileRejection(this.selectedRows),
		},
	];

	private updateTableFiltersWithFileState(fileState: string): void {
		const fileStatusFilter = this.tableFilters.find((filter) => filter.field === 'FileStatus');
		if (fileStatusFilter) {
			fileStatusFilter.value = [fileState];

			const filtersToStore = this.tableFilters.map((filter) => ({
				...filter,
				value: filter.field === 'FileStatus' ? [fileState] : filter.value,
			}));

			this.filterService.storeFilters('files-integration-search', filtersToStore, '/files-integration', true);

			this.cdr.detectChanges();
			this.cdr.markForCheck();

			this.customTable?.triggerFinalRerender();
		}
	}
}
